import { IGatewayError } from './IGatewayError';
import { GatewayErrorResponseCode } from './GatewayErrorResponseCode';
import { isGatewayError } from './isGatewayError';

export function hasGatewayErrorCode(
	error: Error | IGatewayError,
	code: GatewayErrorResponseCode,
) {
	if (!isGatewayError(error)) {
		return false;
	}

	return error.response.data.code === code;
}
